/* OKO 2.0 — territory
   The shop sells online in the UK only. Shopify's own geolocation endpoint
   (the same one Markets uses) says which country the visitor's IP is in;
   outside the UK the shop controls step back and the distributor route
   leads, with a one-line way back for travellers and VPNs ("In the UK?").
   The answer is cached for the session, the visitor's own choice beats
   detection, and every failure mode — endpoint down, storage blocked, slow
   network — falls back to showing the shop. Never hide the till from
   someone who can pay at it. */
(function(){
  var KEY = 'oko2:geo';
  var root = document.documentElement;

  function apply(cc){
    root.classList.toggle('oko2-abroad', cc !== 'GB');
  }

  /* ---- default language by country ----
     First visit only. The country map below is the last resort: a language
     the visitor chose before, then their browser's language, come first
     (see pickLang).
     Mexico → es, Switzerland → de, Belgium → nl (Dutch is the majority
     language), Ukraine → en. Guards, in order: never twice per session;
     never over an explicit choice (the switcher's URL is that choice —
     anyone already on /es, /de… stays put); never to a language that is
     not published, which also keeps the whole feature dormant until
     publish day. */
  var COUNTRY_LANG = {
    ES:'es', MX:'es', AR:'es', CO:'es', CL:'es', PE:'es', VE:'es', EC:'es',
    GT:'es', CU:'es', BO:'es', DO:'es', HN:'es', PY:'es', SV:'es', NI:'es',
    CR:'es', PA:'es', UY:'es', GQ:'es', PR:'es',
    DE:'de', AT:'de', CH:'de', LI:'de',
    FR:'fr', MC:'fr', LU:'fr', BJ:'fr', BF:'fr', CD:'fr', CG:'fr', CI:'fr',
    GA:'fr', GN:'fr', ML:'fr', NE:'fr', SN:'fr', TG:'fr', CM:'fr', HT:'fr',
    NL:'nl', BE:'nl', SR:'nl'
  };
  var LKEY = 'oko2:langdone';
  /* The visitor's own pick in the language switcher, remembered on this
     browser (not just this visit) so it sticks next time. */
  var PKEY = 'oko2:lang';

  /* Which language to land on, strongest signal first:
     1. the language they chose themselves in the switcher (remembered);
     2. their browser's language, if OKO offers it — an English-speaking
        browser in Spain stays English, a French browser in Belgium gets
        French, a German browser anywhere gets German;
     3. the IP country's most-spoken language (COUNTRY_LANG);
     4. English. */
  function pickLang(cc, offered){
    var p = null;
    try { p = localStorage.getItem(PKEY); } catch(e){}
    if (p && offered.indexOf(p) > -1) return p;
    var langs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < langs.length; i++) {
      var base = String(langs[i] || '').toLowerCase().split('-')[0];
      if (base && offered.indexOf(base) > -1) return base;
    }
    return COUNTRY_LANG[cc] || 'en';
  }

  function autoLang(cc){
    var el = document.getElementById('oko2Geo');
    if (!el) return;
    var cur = el.getAttribute('data-locale') || 'en';
    var offered = (el.getAttribute('data-locales') || 'en').split(',');
    var done = null;
    try { done = sessionStorage.getItem(LKEY); } catch(e){ return; }
    if (done || cur !== 'en') return;
    try { sessionStorage.setItem(LKEY, '1'); } catch(e){}
    var target = pickLang(cc, offered);
    if (target === 'en' || offered.indexOf(target) < 0) return;
    location.replace('/' + target + location.pathname + location.search + location.hash);
  }

  /* Remember a language picked in the switcher (header dropdown or drawer). */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('form.shopify-localization-form button[name="locale_code"]');
    if (!b || !b.value) return;
    try { localStorage.setItem(PKEY, b.value); } catch(e){}
  }, true);

  var saved = null;
  try { saved = sessionStorage.getItem(KEY); } catch(e){}
  if (saved) {
    apply(saved);
    autoLang(saved);
  } else {
    fetch('/browsing_context_suggestions.json', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var cc = (((d || {}).detected_values || {}).country || {}).handle || 'GB';
        try { sessionStorage.setItem(KEY, cc); } catch(e){}
        apply(cc);
        autoLang(cc);
      })
      .catch(function(){ /* unknown = show the shop */ });
  }

  /* "In the UK? show prices & buy" — an explicit choice, so it wins for the
     rest of the session on every page. */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-geo-reveal]');
    if (!b) return;
    e.preventDefault();
    try { sessionStorage.setItem(KEY, 'GB'); } catch(e){}
    apply('GB');
  });
})();
